import React from "react";
import servicesContact from "assets/services-image/services_contacts.png";

const Contact = () => {
  return (<div className="services-section mobile-reverse--image">
    <div className="services-section--image">
      <img src={servicesContact} alt="Contact"/>
    </div>
    <div className="services-section--content">
      <h2>Contact</h2>
      <ul>
        <li>
          <p><b>Contact Management:</b> Centralized database for all contacts.</p>
        </li>
        <li>
          <p><b>Communication History:</b> Record of all interaction (emails, calls, meetings).</p>
        </li>
        <li>
          <p><b>Segmentation:</b> Group contact based on criteria like location, property interest, etc.</p>
        </li>
        <li>
          <p><b>Notes and Attachments:</b> Add notes and upload documents related to contacts.</p>
        </li>
        <li>
          <p><b>Social Media Integration:</b> Sync contact details with social media profiles.</p>
        </li>
      </ul>
    </div>
  </div>);
};

export default Contact;
